<div [ngClass]="layoutClass">
  <div *ngIf="isLoading()">
    <waitLoading></waitLoading>
  </div>

  <div *ngIf="isError()">
    <!--
      TODO: Comporbar que el servicio no devuelve datos y mostrar la informaci�n
    -->
    <div class="col-lg-12 alert alert-info ">
      <span class="fa-stack fa-lg">
        <i class="fa fa-circle-o fa-stack-2x" aria-hidden="true"></i>
        <i class="fa fa-info fa-stack-1x" aria-hidden="true"></i>
      </span>
      {{ 'Widget.error' | translate }}
    </div>
  </div>

  <div *ngIf="!isError() && !isLoading()">
    <!-- 1. ZONA MENSAJE -->
    <blockquote class="lead">
      <i class="fa fa-2x fa-info-circle" aria-hidden="true"></i>
      {{ 'TenderEvent.helpMessage' | translate }}
    </blockquote>
    <!-- FIN ZONA MENSAJE -->

    <!-- 2. ZONA BOTONES ARRIBA -->
    <div class="row">
      <!-- updateTasks -->
      <button (click)="taskService.consultaTareas()" class="btn btn-default btn-sm float-right">
        <i class="fa fa-inbox" aria-hidden="true"></i>
        <span class="d-none d-sm-inline">
          {{ 'Tasks.updateTaskList' | translate }}
        </span>
      </button>
    </div>

    <!--
      <div class="row">
        <button class="btn btn-xs btn-default float-right">
          <i aria-hidden="true" class="fas fa-download"></i> Exportar CSV
        </button>
      </div>
    -->

    <!-- 3. ZONA DE DATOS -->
    <!-- 3.a MODO 1: LISTA DE TAREAS ESTANDAR -->
    <!--
      <tasksListComponent [(tasksList)]="filteredTasks"></tasksListComponent>
    -->
    <!-- 3.b MODO 2: LISTA DE MESAS ESTANDAR -->
    <div *ngFor="let task of filteredTasks" class="row">
      <p-table [value]="filteredTasks" sortField="arrivalDate" sortOrder="-1" [rows]="15" [paginator]="true"
        [pageLinks]="4" [rowsPerPageOptions]="[15, 30, 60, 100]" class="footer-over-pagination"
        emptyMessage="{{ 'General.noFilteredData' | translate }}">


        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="arrivalDate">{{ 'PendingTasks.arrival' | translate }} <p-sortIcon field="arrivalDate">
              </p-sortIcon>
            </th>
            <th pSortableColumn="description" styleClass="col-9 col-sm- text-left">{{ 'PendingTasks.description' |
              translate }} <p-sortIcon field="description">
              </p-sortIcon>
            </th>
            <th styleClass="text-center action-column"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-task>
          <tr>
            <td field="arrivalDate">
              <time [dateTime]="task.arrivalDate | date: 'yyyy-MM-dd'" class="icon">
                <em>{{ task.arrivalDate | date: 'EEEE' }}</em>
                <strong>{{ task.arrivalDate | date: 'LLLL' }}</strong>
                <span>{{ task.arrivalDate | date: 'dd' }}</span>
              </time>
            </td>
            <td field="description">
              <div>
                <a *ngIf="taskService.isActiveTask(task)" (click)="taskService.openTask(task)">
                  {{ task?.description }}</a>
                <span *ngIf="!taskService.isActiveTask(task)">{{
                  task?.description
                  }}</span>
              </div>
              <div>
                <dossierDetail [dossier]="task.dossier" [showDivisionInfo]="true"></dossierDetail>
              </div>
            </td>
            <td>
              <a *ngIf="!this.taskService.isActionAvailable(task, TASK_UNLOCK)" class="btn btn-default btn-sm"
                (click)="taskService.openTask(task)">
                <i class="fa fa-2x fa-sign-in" aria-hidden="true"></i><span class="d-none d-sm-inline"></span>
              </a>
              <a *ngIf="this.taskService.isActionAvailable(task, TASK_UNLOCK)" class="btn btn-danger btn-sm"
                (click)="unlock(task)">
                <i class="fa fa-2x fa-unlock-alt" aria-hidden="true"></i><span class="d-none d-sm-inline"></span>
              </a>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <!-- FIN ZONA DE DATOS -->

    <!-- 4. ZONA DE COMPROBACION DE HERRAMIENTA -->
    <div class="row">
      <div class="col-12 col-md-6">
        <p-panel>
          <p-header>
            <span>
              <i class="fa fa-wrench" aria-hidden="true"></i>
              {{ 'TenderEvent.checkToolTitle' | translate }}</span>
          </p-header>

          <div class="ui-widget-content p-h-m">
            <span [innerHTML]="
                translateService.instant('TenderEvent.checkToolText')
              "></span>
          </div>
          <div class="ui-menubar ui-widget ui-widget-content ui-corner-all p-h-m">
            <button *ngIf="!estadoFerramenta" class="btn btn-primary" style="width: 100%" (click)="startFerramenta()">
              <i class="fas fa-play" aria-hidden="true"></i>
              {{ 'TenderEvent.checkToolAction' | translate }}
            </button>
            <div *ngIf="estadoFerramenta">
              <!--
                <a (click)="stopFerramenta()"
                  ><i class="fa fa-stop" aria-hidden="true"></i
                ></a>
              -->
              <span><i class="fas fa-sync-alt loading-spin" aria-hidden="true"></i>
                {{ estadoFerramenta }}</span>
            </div>
          </div>
        </p-panel>
      </div>
    </div>
    <!-- FIN ZONA DE COMPROBACI�N DE HERRAMIENTA -->
  </div>
</div>